import React, {useEffect, useState} from "react";
import {IQuestion} from "../../../data/interfaces/IQuestion";
import "./style.scss";


export function RadioQuestionComponent(props: {
    question: IQuestion,
    onChange: (node: IQuestion) => void;
}) {

    const { question, onChange } = props;

    const change = () => {
        question.isValid = !(question.selectedValue === undefined || (
            question.allowCustomAnswer === true
            && question.selectedValue === question.options.length
            && (question.customAnswer === undefined || question.customAnswer.trim().length === 0)
        ));

        onChange(question);
    }

    return (
        <div className="survey-form-section">
            {
                (question.text !== undefined) && (
                    <label className="survey-form-section-label" htmlFor="name">
                        {question.text}
                    </label>
                )
            }

            <div className="survey-form-section-content">

                <div className="survey-form-radio-buttons-list">
                    {
                        question.options.map((option, optionIndex) => {
                            return (
                                <label className="survey-form-radio-button-container" key={optionIndex}>
                                    <input className="survey-form-radio-button-input"
                                           type="radio"
                                           name={question.id.toString()}
                                           onChange={(event) => {
                                               if (event.target.checked) {
                                                   question.selectedValue = optionIndex + 1;
                                                   change();
                                               }
                                           }}
                                    />
                                    <span className="survey-form-radio-button-checkmark"></span>
                                    <span>{option.optionText}</span>
                                    <div className="survey-form-radio-button-outline-effect"></div>
                                </label>
                            )
                        })
                    }
                </div>

                {
                    (question.allowCustomAnswer === true && question.selectedValue === question.options.length) && (
                        <div className="survey-form-textarea-container">
                            <textarea
                                className="survey-form-input"
                                rows={6}
                                placeholder="Введите текст..."
                                value={question.customAnswer}
                                onChange={(event) => {
                                    question.customAnswer = event.target.value;
                                    change();
                                }}
                            />
                        </div>
                    )
                }

            </div>

        </div>
    )
}